import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '&.collection-explorer': {
    padding: `${theme.space[3]} ${theme.space[4]}`,
  },
});
